import { RectangleSkeleton } from '@/components/atoms/Skeleton';

const ForexListSkeleton = () => {
  return (
    <div className='h-[582px] w-full'>
      <div className='h-[46px] py-4'>
        <RectangleSkeleton height='100%' width='100%' />
      </div>
      {Array(8)
        .fill(0)
        .map((_: number, index: number) => (
          <div key={`skeleton-${index}`} className='h-[62px] w-full border-b border-[#e2e8f1] py-4'>
            <RectangleSkeleton height='100%' width='100%' />
          </div>
        ))}
      <div className='mx-auto mt-4 flex h-6 w-[140px] items-center justify-center'>
        <RectangleSkeleton height='100%' width='100%' />
      </div>
    </div>
  );
};

export default ForexListSkeleton;
